
import { Component, ChangeDetectionStrategy, inject, signal, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { PlatformService } from '../../../services/platform.service';
import { AppUser } from '../../../models/index';
import { NotificationService } from '../../../services/notification.service';
import { InvitePlatformStaffModalComponent } from '../invite-platform-staff-modal/invite-platform-staff-modal.component';

@Component({
  selector: 'app-platform-team',
  standalone: true,
  imports: [CommonModule, DatePipe, InvitePlatformStaffModalComponent],
  templateUrl: './platform-team.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlatformTeamComponent implements OnInit {
  private platformService = inject(PlatformService);
  private notificationService = inject(NotificationService);

  team = signal<AppUser[]>([]);
  isLoading = signal(true);
  isInviteModalOpen = signal(false);

  ngOnInit() {
    this.loadTeam();
  }

  async loadTeam() {
    this.isLoading.set(true);
    try {
      this.team.set(await this.platformService.getPlatformTeam());
    } catch (e: any) {
      this.notificationService.showError("Failed to load platform team: " + e.message);
    } finally {
      this.isLoading.set(false);
    }
  }

  openInviteModal() {
    this.isInviteModalOpen.set(true);
  }

  getRoleColor(role: string): string {
    switch(role) {
      case 'platform_admin': return 'bg-purple-900/50 text-purple-400 border-purple-500/30';
      case 'platform_accountant': return 'bg-emerald-900/50 text-emerald-400 border-emerald-500/30';
      case 'platform_auditor': return 'bg-blue-900/50 text-blue-400 border-blue-500/30';
      default: return 'bg-slate-800 text-slate-400 border-slate-600';
    }
  }

  getInitials(name: string): string {
      if (!name) return '??';
      return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
  }
}
